module.exports = __webpack_public_path__ + "c3f707f96ad576f68c2a6788fd3c1320.svg";